module.exports = __webpack_public_path__ + "img/report_logo.b237475a.png";